import { SignatureTemplateData } from "./onboarding.interface";

function renderIconHtml(icon: {
  platform?: string;
  imageUrl?: string;
  alt?: string;
}): string {
  if (icon.platform?.startsWith("custom_")) {
    return `<img src="${icon.imageUrl || ""}" alt="${icon.alt || ""}" width="28" height="28" style="width: 28px; height: 28px;">`;
  }
  return icon.imageUrl || "";
}

export function generateSignatureTemplate(data: SignatureTemplateData): string {
  const userThumbnail = data.userThumbnail?.trim()
    ? `<td>${data.userThumbnail}</td>`
    : "";

  const jobTitleRow = data.jobTitle?.trim()
    ? `<tr><td style="line-height: 14px; padding-bottom: 5px;"><span style="font-family: Arial, sans-serif; font-size: 14px; font-weight: 400; color: #000000;">${data.jobTitle}</span></td></tr>`
    : "";

  const phoneIcon = data.socialMediaIcons?.find(
    (icon) => icon.name === "Phone",
  );
  const emailIcon = data.socialMediaIcons?.find(
    (icon) => icon.name === "Email",
  );
  const wwwIcon = data.socialMediaIcons?.find(
    (icon) => icon.name === "Website",
  );

  const phoneRow = data.phoneNumber?.trim()
    ? `<tr><td style="padding-top: 5px;"><table style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0"><tr><td>${phoneIcon?.imageUrl || ""}</td><td style="padding-left: 5px; line-height: 14px;"><a href="tel:${data.phoneNumber}" style="font-family: Arial, sans-serif; font-weight: 400; text-decoration: none; font-size:14px; color: #000000;" target="_blank">${data.phoneNumber}</a></td></tr></table></td></tr>`
    : "";

  const emailRow = data.userEmail?.trim()
    ? `<tr><td style="padding-top: 5px;"><table style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0"><tr><td>${emailIcon?.imageUrl || ""}</td><td style="padding-left: 5px; line-height: 14px;"><a href="mailto:${data.userEmail}" style="font-family: Arial, sans-serif; font-weight: 400; text-decoration: none; font-size:14px; color: #000000;" target="_blank">${data.userEmail}</a></td></tr></table></td></tr>`
    : "";

  const wwwRow = data.website?.trim()
    ? `<tr><td style="padding-top: 5px;"><table style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0"><tr><td>${wwwIcon?.imageUrl || ""}</td><td style="padding-left: 5px; line-height: 14px;"><a href="https://${data.website}" style="font-family: Arial, sans-serif; font-weight: 400; text-decoration: none; font-size:14px; color: #000000;" target="_blank">${data.website}</a></td></tr></table></td></tr>`
    : "";

  const hasCompanyData =
    data.companyName?.trim() || data.companyAddress?.trim();
  const hasCompanyImage = data.companyImage?.trim();

  const companySection =
    hasCompanyData || hasCompanyImage
      ? `<tr><td style="padding-top: 20px; border-bottom: 1px solid #D9D9D9;"></td></tr><tr><td><table width="400" style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0"><tr>${hasCompanyData ? `<td align="left" style="padding-top: 10px; align-items: left;"><table style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0">${data.companyName?.trim() ? `<tr><td><span style="font-family: Arial, sans-serif; font-size: 14px; font-weight: 600; color: #000000;">${data.companyName}</span></td></tr>` : ""}${data.companyAddress?.trim() ? `<tr><td style="padding-top: 2px;"><span style="font-family: Arial, sans-serif; font-size: 12px; color: #000000;">${data.companyAddress}</span></td></tr>` : ""}</table></td>` : ""}${hasCompanyImage ? `<td align="right" style="padding-top: 10px; align-items: right;">${data.companyImage}</td>` : ""}</tr></table></td></tr>`
      : "";

  const socialMediaIcons =
    data.socialMediaIcons?.filter(
      (icon) => !["Phone", "Email", "Website"].includes(icon.name),
    ) || [];

  const socialMediaIconsRow =
    socialMediaIcons.length > 0
      ? `<tr><td style="padding-top: 20px; border-bottom: 1px solid #D9D9D9;"></td></tr><tr><td style="padding-top: 10px;"><table style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0"><tr>${socialMediaIcons
          .map((icon) => {
            const iconHtml = renderIconHtml(icon);
            const hasUrl = icon.url && icon.url.trim() !== "";
            return hasUrl
              ? `<td style="padding: 0 5px;"><a href="${icon.url}" style="text-decoration: none;" target="_blank">${iconHtml}</a></td>`
              : `<td style="padding: 0 5px;">${iconHtml}</td>`;
          })
          .join("")}</tr></table></td></tr>`
      : "";

  return `<table width="400" style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0"><tr><td><table style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0"><tr>${userThumbnail}<td style="padding-left: 10px;"><table style="border-collapse:collapse;" cellspacing="0" cellpadding="0" border="0"><tr><td style="line-height: 17px;"><span style="font-family: Arial, sans-serif; font-size: 17px; font-weight: 700; color: #000000;">${data.userName}</span></td></tr>${jobTitleRow}${phoneRow}${emailRow}${wwwRow}</table></td></tr></table></td></tr>${companySection}${socialMediaIconsRow}</table><br>`;
}
